"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./collectionTitleDescBlock.scss");
const CollectionTitleDescBlockTranslations_json_1 = __importDefault(require("./collectionTitleDescBlockTranslations/CollectionTitleDescBlockTranslations.json"));
const CollectionTitleDescBlockLoader_1 = __importDefault(require("./collectionTitleDescBlockLoaders/CollectionTitleDescBlockLoader"));
function CollectionTitleDescBlock(props) {
    props.addTranslation(CollectionTitleDescBlockTranslations_json_1.default);
    return props.loading ? (react_1.default.createElement(CollectionTitleDescBlockLoader_1.default, Object.assign({}, props))) : (react_1.default.createElement("div", { id: "collection-title-desc-block" },
        react_1.default.createElement("span", { className: "collection-title" }, props.collection.title),
        react_1.default.createElement("div", { className: "collection-desc-col" },
            react_1.default.createElement("span", { className: "collection-desc-label" }, props.translate("collectionDescription").toString()),
            react_1.default.createElement("span", { className: "collection-desc" }, props.collection.description))));
}
exports.default = CollectionTitleDescBlock;
